module.exports = __webpack_public_path__ + "img/winner7.727c15c6.png";